import React from 'react';
import { Cog6ToothIcon, UserIcon, ShieldCheckIcon } from '@heroicons/react/24/outline';

const Settings: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Settings</h1>
        <p className="text-gray-600 mt-2">Configure application preferences and settings</p>
      </div>

      <div className="space-y-6">
        <div className="bg-white rounded-lg shadow-md p-6">
          <div className="flex items-center mb-4">
            <UserIcon className="w-6 h-6 text-gray-600 mr-3" />
            <h2 className="text-lg font-semibold">User Preferences</h2>
          </div>
          <div className="space-y-4">
            <div>
              <label className="form-label">Theme</label>
              <select className="form-input">
                <option>Light</option>
                <option>Dark</option>
                <option>Auto</option>
              </select>
            </div>
            <div>
              <label className="form-label">Language</label>
              <select className="form-input">
                <option>English</option>
                <option>German</option>
                <option>French</option>
              </select>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-md p-6">
          <div className="flex items-center mb-4">
            <Cog6ToothIcon className="w-6 h-6 text-gray-600 mr-3" />
            <h2 className="text-lg font-semibold">System Settings</h2>
          </div>
          <div className="space-y-4">
            <div className="flex items-center">
              <input type="checkbox" id="autoSave" className="mr-2" />
              <label htmlFor="autoSave" className="text-sm text-gray-700">
                Enable auto-save
              </label>
            </div>
            <div className="flex items-center">
              <input type="checkbox" id="notifications" className="mr-2" />
              <label htmlFor="notifications" className="text-sm text-gray-700">
                Enable notifications
              </label>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-md p-6">
          <div className="flex items-center mb-4">
            <ShieldCheckIcon className="w-6 h-6 text-gray-600 mr-3" />
            <h2 className="text-lg font-semibold">Security</h2>
          </div>
          <div className="space-y-4">
            <button className="btn-secondary">Change Password</button>
            <button className="btn-secondary">Two-Factor Authentication</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
